import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/system-tasks`;
export const modelName = 'system-task';

export default {
  ...apiCrud({ baseUri, modelName }),

  execute: async ({ id }) => await axios.post(`${ baseUri }/${ id }/execute`),
  cancelSubscription: async (data) => {
    const { offerCode } = data;
    return await axios.delete(
      `${ baseUri }/offers/${ offerCode }/system-tasks`,
    );
  },
};
